import React from 'react';
import { Globe } from 'lucide-react';
import ServiceHeader from '../../components/services/ServiceHeader';
import ServiceFeatureCard from '../../components/ui/ServiceFeatureCard';
import { colors } from '../../styles/theme';
import ServiceSteps from '../../components/services/sections/ServiceSteps';

const features = [
  {
    iconName: "Server",
    title: "SSD NVMe Space",
    description: "100GB of ultra-fast storage"
  },
  {
    iconName: "Database",
    title: "Databases",
    description: "MySQL, PostgreSQL, and MongoDB included"
  },
  {
    iconName: "Code",
    title: "Technologies",
    description: "PHP, Node.js, Python, and more"
  },
  {
    iconName: "Shield",
    title: "Free SSL",
    description: "Automatic Let's Encrypt certificates"
  },
  {
    iconName: "Zap",
    title: "Performance",
    description: "Optimized servers and CDN included"
  },
  {
    iconName: "Clock",
    title: "Backup",
    description: "Automatic daily backups"
  }
];

const steps = [
  {
    title: "Sign up on EUROPEAN STUDENT",
    description: "Create your student account in just a few clicks"
  },
  {
    title: "Verify your student status",
    description: "Upload your student card or enrollment certificate"
  },
  {
    title: "Order your hosting",
    description: "Choose your domain name and deploy your website!"
  }
];

const HostingPage = () => {
  const handleOrder = () => {
    window.location.href = 'https://my.europeanstudent.org/store/web';
  };
  return (
    <div>
      <ServiceHeader
        title="Web Hosting"
        description="High-performance web hosting for your projects, with all modern technologies included."
        icon={<Globe className="w-8 h-8 text-white" />}
        color={colors.tertiary}
        imageUrl="https://i.imgur.com/j2t4g6i.jpeg"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Features */}
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <ServiceFeatureCard
              key={index}
              iconName={feature.iconName}
              title={feature.title}
              description={feature.description}
              color={colors.tertiary}
            />
          ))}
        </div>

        {/* Technical Specifications */}
        <section className="mt-16">
          <h2 className="text-2xl font-bold mb-8">Technical Specifications</h2>
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h3 className="font-semibold mb-4">Infrastructure</h3>
                <ul className="space-y-3 text-gray-600">
                  <li>• Next-generation servers</li>
                  <li>• SSD NVMe drives in RAID</li>
                  <li>• Unlimited bandwidth</li>
                  <li>• DDoS protection included</li>
                  <li>• Datacenters in France</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold mb-4">Supported Technologies</h3>
                <ul className="space-y-3 text-gray-600">
                  <li>• PHP 7.4, 8.0, 8.1, 8.2</li>
                  <li>• Node.js 14, 16, 18, 20</li>
                  <li>• Python 3.8, 3.9, 3.10, 3.11</li>
                  <li>• Ruby, Perl, Java</li>
                  <li>• SSH and SFTP included</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <div className="pt-11">
          <ServiceSteps
                title="How to Benefit"
                steps={steps}
                color={colors.tertiary}
                ctaText="Activate my web hosting"
                onCtaClick={handleOrder}
          />
        </div>
      </div>
    </div>
  );
};

export default HostingPage;